import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";

import axios from "../../../interceptors/axiosInstance";
import { Table } from "../../../components/Table/Table";
import { LoaderContext } from "../../../context/LoaderContext";
import { config } from "../../../config";
import { MessageContext } from "../../../context/MessageContext";
import { getErrorMessage } from "../../../utils/ErrorMessage";
import "./managePPAValuations.css";
import { pascalCase, upperCase } from "../../../utils/display";

export const ManagePPAValuations = () => {
  const [valuations, setValuations] = useState([]);
  const { setLoading } = useContext(LoaderContext);
  const { ErrorToast } = useContext(MessageContext);

  const navigate = useNavigate();

  const columnHelper = createColumnHelper();

  useEffect(() => {
    fetchValuations();
  }, []);

  const fetchValuations = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.BASE_URL}/api/ppa/valuations`);
      setValuations(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = getErrorMessage(error);
      ErrorToast(errorMessage);
    }
  };

  const actionIconPath = {
    View: {
      actionIcon: "checkbox_active.svg",
      btnIcon: "checkbox_active.svg",
      btnColor: "#FF9A91",
    },
    New: {
      actionIcon: "add.svg",
      btnIcon: "add.svg",
      btnColor: "#8DE8AD",
    },
  };

  const columns = [
    columnHelper.accessor("valuationDate", {
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
      header: "Valuation Date",
      enableGlobalFilter: true,
    }),
    columnHelper.accessor("valuationClientType", {
      cell: (info) => pascalCase(info.getValue(), "_"),
      footer: (info) => info.column.id,
      header: "Clinet Type",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("ppaLocation", {
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
      header: "PPA Location",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("contractStartDate", {
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
      header: "Contract Start Date",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("contractEndDate", {
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
      header: "Contract End Date",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("valuationAtInception", {
      cell: (info) => upperCase(info.getValue()),
      footer: (info) => info.column.id,
      header: "Valuation At Inception",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("calibrationAdjustment", {
      cell: (info) => (info.getValue() || 0).toFixed(2),
      footer: (info) => info.column.id,
      header: "Calibration Adjustment",
      enableGlobalFilter: false,
    }),
    columnHelper.accessor("totalValuation", {
      cell: (info) => (info.getValue() || 0).toFixed(2),
      footer: (info) => info.column.id,
      header: "Total Valuation",
      enableGlobalFilter: false,
    }),
    columnHelper.display({
      id: "actions",
      cell: (props) => {
        return (
          <div className="valuation-action-container">
            <span
              className="valuation-action"
              title="View Valuation"
              onClick={() => {
                selectData(props.row.original, "read");
              }}
            >
              &#10132;
            </span>

            <span
              className="valuation-action"
              title="New Valuation"
              onClick={() => {
                selectData(props.row.original, "new");
              }}
            >
              &#10011;
            </span>
          </div>
        );
      },
      header: "Actions",
    }),
  ];

  const selectData = (valuation, mode) => {
    window.scrollTo(0, 0);
    navigate("/PPAValuation", {
      state: { id: valuation?.id, mode },
    });
  };

  return (
    <div className="manage-valuations-container">
      <Table
        columns={columns}
        data={valuations}
        placeholder="Search By Valuation Date"
        setData={setValuations}
      />
    </div>
  );
};
